/**
 * Envanter varlık kategorisi anahtarları — AssetInfoCard / AssetRelationshipGraph ile aynı kaynak.
 * Ana sayfa dağılımı ve diğer özetler bu eşlemeyi kullanır.
 */

export const ASSET_CATEGORY_UI_GROUPS = {
    businessAssets: [
        'businessProcess', 'service', 'function', 'capability'
    ],
    informationAssets: [
        'dataSet', 'database', 'log', 'intellectualProperty', 'configurationData'
    ],
    applicationAssets: [
        'webApplication', 'backendService', 'api', 'microservice', 'batchJob', 'aiModel', 'script'
    ],
    infrastructureAssets: [
        'physicalServer', 'virtualMachine', 'container', 'operatingSystem', 'networkDevice',
        'storage', 'hardware', 'software', 'cloudResource',
        'workstation', 'endpoint', 'mobileDevice'
    ],
    locationAssets: [
        'dataCenter', 'office', 'drSite', 'cloudRegion'
    ],
    humanAssets: [
        'administrator', 'developer', 'operator', 'thirdPartyPersonnel'
    ],
    thirdPartyAssets: [
        'saas', 'cloudProvider', 'externalApi', 'vendorSystem'
    ]
};

const LEGACY_CATEGORY_TO_GROUP = {
    Hardware: 'infrastructureAssets',
    Software: 'applicationAssets',
    Location: 'locationAssets',
    Applications: 'applicationAssets',
    hardware: 'infrastructureAssets',
    software: 'applicationAssets',
    location: 'locationAssets',
    applications: 'applicationAssets'
};

const CATEGORY_TO_GROUP = new Map();
for (const [group, keys] of Object.entries(ASSET_CATEGORY_UI_GROUPS)) {
    for (const k of keys) {
        CATEGORY_TO_GROUP.set(k, group);
    }
}

/**
 * DB'deki Asset.category değerini UI varlık grubuna eşler (bilinmeyenler "unmapped").
 * @param {string|null|undefined} category
 * @returns {'businessAssets'|'informationAssets'|'applicationAssets'|'infrastructureAssets'|'locationAssets'|'humanAssets'|'thirdPartyAssets'|'unmapped'}
 */
export function getAssetCategoryUiGroup(category) {
    if (category === null || category === undefined) {
        return 'unmapped';
    }
    const raw = String(category).trim();
    if (raw === '') {
        return 'unmapped';
    }

    if (Object.prototype.hasOwnProperty.call(LEGACY_CATEGORY_TO_GROUP, raw)) {
        return LEGACY_CATEGORY_TO_GROUP[raw];
    }
    const legacyLower = raw.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(LEGACY_CATEGORY_TO_GROUP, legacyLower)) {
        return LEGACY_CATEGORY_TO_GROUP[legacyLower];
    }

    if (CATEGORY_TO_GROUP.has(raw)) {
        return CATEGORY_TO_GROUP.get(raw);
    }

    const lower = raw.toLowerCase();
    for (const [key, group] of CATEGORY_TO_GROUP) {
        if (key.toLowerCase() === lower) {
            return group;
        }
    }

    return 'unmapped';
}
